import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Services from './components/Services/ServicesPage';
import Contact from './components/Contact/ContactPage';
import About from './components/About/AboutPage';
import Terms from './components/Terms/TermsPage';
import Policy from './components/Policy/PolicyPage';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path = "/" element = {<App />}></Route>
      <Route path = "/services" element = {<Services />}></Route>
      <Route path = "/contact" element = {<Contact />}></Route>
      <Route path = "/about" element = {<About />}></Route>
      <Route path = "/terms" element = {<Terms />}></Route>
      <Route path = "/policy" element = {<Policy />}></Route>
    </Routes>
  </BrowserRouter>
);

